import { render, staticRenderFns } from "./PregnancyPeriod.vue?vue&type=template&id=1c4e916a&"
import script from "./PregnancyPeriod.vue?vue&type=script&lang=js&"
export * from "./PregnancyPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports